import "babel-polyfill"
import React from 'react'
import {render} from 'react-dom'
import registerServiceWorker from './registerServiceWorker'
import configureStore from 'shared/store'
import './index.css'

import t from 'tcomb-form'
import templates from 'shared/components/tcomb/semantic'

t.form.Form.templates = templates


const startApp = () => {
    const Root = require('shell/Root').default
    const store = configureStore()
    const rootEl = document.getElementById('root')

    if (process.env.NODE_ENV === 'production') {
        render(<Root store={store}/>, rootEl)
    } else {
        require('react-hot-loader/patch')
        const AppContainer = require('react-hot-loader').AppContainer

        render(
            <AppContainer>
                <Root store={store}/>
            </AppContainer>,
            rootEl
        )

        if (module.hot) {
            module.hot.accept('shell/Root', () => {
                import('shell/Root')
                    .then(RootComponent => {
                        const NextRoot = RootComponent.default
                        render(
                            <AppContainer>
                                <NextRoot store={store}/>
                            </AppContainer>,
                            rootEl
                        )
                    })
                    .catch(err => {
                        // Insert your instrumentation here , see sabre-ui-logger component for ELK, appDynamics.
                    })
            })
        }
    }
}


startApp()
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js